import get from 'lodash/get';

export const getPlacementById = (state, id) => state.placements[id];
export const getPlacementContentById = (state, id) => get(state.placements[id], 'content');
